var breakpoints = {
	this : null,
	set : null,
	switch : {
		device : null,
		orientation: null,
	},
	resized : null,
	first : true,
	init : null,
};

breakpoints.set = function() {
	let newBreakpoint;
	if (Modernizr.mq('(max-width: 767px)')) {
		newBreakpoint = 'mobile';
	} else if (Modernizr.mq('(max-width: 1023px)')) {
		newBreakpoint = 'tablet portrait';
	} else if (Modernizr.mq('(max-width: 1279px)')) {
		newBreakpoint = 'tablet landscape';
	} else if (Modernizr.mq('(min-width: 1600px)')) {
		newBreakpoint = 'desktop hd';
	} else {
		newBreakpoint = 'desktop ';
	}
	if (newBreakpoint != breakpoints.this) {
		const breakpointsClasses = ['mobile', 'tablet', 'desktop', 'portrait', 'landscape' , 'hd'];
		$.each(breakpointsClasses, function(i, v){
			$('html').removeClass(v);
		});
		breakpoints.this = newBreakpoint;
		$('html').addClass(breakpoints.this);
		if (breakpoints.first == true) {
			breakpoints.first = false;
		} else {
			breakpoints.switch.device(breakpoints.this);
		}
	}
};

breakpoints.init = function() {
	var resize;
	$(window).resize(function(){
		clearTimeout(resize);
		resize = setTimeout(function() {
			breakpoints.set();
			breakpoints.resized();
		}, 100);
	});
	window.addEventListener('orientationchange', breakpoints.switch.orientation);
	breakpoints.set();
}

export { breakpoints }
